<template>
<div class="chapter">
<div class="inner_page">
<p class="title" id="title"><a id="page_3"><strong>Catching<br/>the<br/>Catfishers</strong></a></p><a id="page_3">
<p class="title1">Disarm the Online Pretenders,<br/>Predators, and Perpetrators<br/>Who Are Out to Ruin Your Life</p>
<p class="titlea">Tyler Cohen Wood</p>
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?a87b8648